module.exports = __webpack_public_path__ + "static/media/CIMFooterGradientOnly.4a5c1789.jpg";